import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable()
export class InvoiceDetailsService {

  constructor(private base: BaseService) { }

  getInvoiceDetails(val){
    return this.base.post('/api/get-invoice-details',{id:val});
  }
 

}